// extracted by mini-css-extract-plugin
export var container = "baseStyles-module__container___FkoS9";
export var row = "baseStyles-module__row___EPPos";
export var section = "baseStyles-module__section___Im9kP";
export var body = "baseStyles-module__body___JGUQt";
export var info = "baseStyles-module__info___GHqm5";
export var link = "baseStyles-module__link___LgK6q";
export var route = "baseStyles-module__route____idGY";
export var action = "baseStyles-module__action___E0dMW";
export var center = "baseStyles-module__center___tvHl5";